import React, { useContext } from "react"
import { Link } from "gatsby"
import UserBadge from "./UserBadge"
import MenuCategory from "./MenuCategory"
import { CaretRight, Lock, MapPinLine, Package, SignOut, TreePalm, UserGear } from "@phosphor-icons/react"
import { useLocation } from "@reach/router"
import UserContext from "@context/UserContext"

const UserAccountSidebar = ({className = 'w-[272px] xl:w-[340px] h-full hidden md:flex flex-col space-y-6 border-r border-r-[#E5E5E5] pb-8 '}) => {
	const { user, handleSignOut } = useContext(UserContext)
	const location = useLocation()

	const closeIfActive = (path) => {
		if(location.pathname === path + "/") {
			
		}
	}

    
	
	return (
		<div className={`${className}`}>
			<UserBadge data={user} isExpanded />
      
	  		<nav className="flex flex-col gap-2 px-4 space-y-4">
				<div className="flex flex-col py-6 border-y border-y-[#E5E5E5] space-y-6">
					<MenuCategory name={'ORDER DETAILS'}>
						<Link 
							to="/user-account/order-history" 
							className={`nav-button ${location.pathname.startsWith("/user-account/order-history") ? 'bg-primary text-white' : ''}`}
							activeClassName="bg-primary text-white"
							onClick={() => closeIfActive('/user-account/order-history')}
						>
							<Package size={16} weight="light" />
							<span>Order History</span>
							<CaretRight className="block md:hidden" size={16} weight="light" />
						</Link>
					</MenuCategory>

					<MenuCategory name={'SETTINGS'}>
						<Link 
							to="/user-account/personal-information" 
							className="nav-button"
							activeClassName="bg-primary text-white"
							onClick={() => closeIfActive('/user-account/personal-information')}
						>
							<UserGear size={16} weight="light" />
							<span>Personal Information</span>
							<CaretRight className="block md:hidden" size={16} weight="light" />
						</Link>
						<Link 
							to="/user-account/shipping-address" 
							className="nav-button"
							activeClassName="bg-primary text-white"
							onClick={() => closeIfActive('/user-account/shipping-address')}
						>
							<MapPinLine size={16} weight="light" />
							<span>Shipping Address</span>
							<CaretRight className="block md:hidden" size={16} weight="light" />
						</Link>
						<Link 
							to="/user-account/change-password" 
							className="nav-button"
							activeClassName="bg-primary text-white"
							onClick={() => closeIfActive('/user-account/change-password')}
						>
							<Lock size={16} weight="light" />
							<span>Change Password</span>
							<CaretRight className="block md:hidden" size={16} weight="light" />
						</Link>
					</MenuCategory>

					
                    <MenuCategory name={'REWARDS'}>
                        <Link 
                            to="/user-account/blackbough-beach-club" 
                            className={`nav-button ${location.pathname.startsWith("/user-account/blackbough-beach-club") ? 'bg-primary text-white' : ''}`}
                            activeClassName="bg-primary text-white"
                            onClick={() => closeIfActive('o="/user-account/blackbough')}
                        >
                            <TreePalm size={16} weight="light" />
                            <span>Blackbough Beach Club</span>
                            <CaretRight className="block md:hidden" size={16} weight="light" />
                        </Link>
                    </MenuCategory>
					
				</div>

				<button 
					className="nav-button text-[#B91C1C] bg-[#FEE2E2]"
					onClick={() => {
						handleSignOut()
					}}
				>
					<SignOut size={16} weight="light" />
					<span className="text-left">Sign Out</span>
				</button>
			</nav>
    	</div>
	)
}

export default UserAccountSidebar